module.exports = "/images/pix-icone.png?774be3abe4583635154c06f5308404b3";